<template>
  <!-- ========== Left Sidebar Start ========== -->
  <div class="vertical-menu2 d-flex flex-column custom-scrollbar" style="background-color: #2A3042;">
    <div class="sidebar--logo">
      <div class="">
        <img :src="whiteLabel || '/logo-white.png'" alt="" height="52" />
      </div>
    </div>

    <router-link tag="a" to="/">
      <div class="user-panel">
        <i class="iconoir-view-grid"></i>
        {{ $t("dashboard.text") }}
      </div>
    </router-link>

    <!-- TKP-143 / tasarım s.33 md.2a-b (karar 2026-09-27): ana ekran çalışma alanı listesi; organizasyonlar / üyeler / kütüphane
         yalnız seçili çalışma alanı bağlamında ve listeden geçilerek. Eski "Çalışma Alanı Paneli" kart panosu kalktı. -->
    <router-link tag="a" to="/workspace" exact data-test="ws-nav-list">
      <div class="menu-item">
        <i class="iconoir-link"></i>
        {{ $t("workspace.my") }}
      </div>
    </router-link>

    <template v-if="selectedWorkspace">
      <div class="workspace-context" data-test="ws-nav-context">
        <small>{{ $t("workspace.selected") }}</small>
        <div class="workspace-context--name" data-test="ws-nav-context-name">{{ selectedWorkspace.name }}</div>
      </div>

      <router-link tag="a" to="/workspace/organizations" data-test="ws-nav-organizations">
        <div class="menu-item">
          <i class="iconoir-building"></i>
          {{ $t("organization.plural") }}
        </div>
      </router-link>

      <router-link tag="a" to="/workspace/members" data-test="ws-nav-members">
        <div class="menu-item">
          <i class="iconoir-community"></i>
          {{ $t("workspace.members") }}
        </div>
      </router-link>
    </template>

    <simplebar v-if="!isCondensed" :settings="settings">
      <SideNav />
    </simplebar>

    <simplebar v-else>
      <SideNav />
    </simplebar>

    <router-link v-if="selectedWorkspace" tag="a" to="/workspace/members">
      <div class="menu-item m-auto mb-5" @click="openInviteModal">
        <i class="iconoir-user-plus"></i>
        {{ $t("workspace.send-invite") }}
      </div>
    </router-link>
  </div>

  <!-- Left Sidebar End -->
</template>

<script>
import simplebar from "simplebar-vue";

import SideNav from "./side-nav";

export default {
  components: { simplebar, SideNav },
  props: {
    isCondensed: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: false,
    },
    width: {
      type: String,
      required: false,
    },
  },
  computed: {
    selectedWorkspace() {
      return this.$store.getters["switchWorkspace/selected"];
    },
  },
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      },
    };
  },
  methods: {
    openInviteModal() {
      this.$store.commit("workspace/showInviteModal", true);
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.user-panel {
  display: flex;
  align-items: center;
  padding-left: 2.5rem;
  gap: 1rem;
  color: #fff;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 3.38rem;
}

.workspace-context {
  max-width: 15rem;
  margin: 0 auto 0.75rem auto;
  padding: 0 1rem;
  color: #8a91a6;
  font-size: 0.75rem;

  &--name {
    color: #fff;
    font-size: 0.875rem;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 1rem;
  color: #535a71;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  max-width: 15rem;
  width: 100%;
  border-radius: 0.625rem;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1rem;
  transition: background-color, color, 0.3s;
  cursor: pointer;

  i {
    position: relative;
    bottom: 1px;
    font-size: 1.5rem;
  }

  &:hover {
    background-color: #202533;
    color: #fff;

    i {
      color: #ff7c48;
    }
  }
}

.mm-active .menu-item {
  background-color: #202533;
  color: #fff;

  i {
    color: #ff7c48;
  }
}

/* width */
.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
}

/* Track */
.custom-scrollbar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 3px rgb(66, 83, 113);
  border-radius: 10px;
}

/* Handle */
.custom-scrollbar::-webkit-scrollbar-thumb {
  // background: rgb(66, 83, 113);
  background-color: #ff7c48;
  border-radius: 10px;
}
</style>
